import { Content, asText, isFilled } from '@prismicio/client';

import {
  Box,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
  Table as OxygenTable,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

type WithTableProps = {
  sliceId: string;
  slice: Content.RegionSliceWithTable;
};

export const WithTable = ({ slice, sliceId }: WithTableProps) => {
  const { primary } = slice;

  const { table, content, table_caption, hide_table_caption } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" addFlow>
      <RichText content={content} variant="default" websiteUrl={WebsiteUrl} />

      {isFilled.table(table) && (
        <OxygenTable
          caption={asText(table_caption)}
          hideCaption={hide_table_caption}
        >
          <TableHeader>
            {(table.head?.rows ?? []).map(({ key, cells }) => (
              <TableRow key={`table-head-row-${sliceId}-${key}`}>
                {cells.map(({ key, content }) => (
                  <TableCell
                    scope="col"
                    component="td"
                    key={`table-head-cell-${sliceId}-${key}`}
                  >
                    <RichText
                      content={content}
                      variant="default"
                      websiteUrl={WebsiteUrl}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHeader>

          <TableBody>
            {(table.body?.rows ?? []).map(({ key, cells }) => (
              <TableRow key={`table-body-row-${sliceId}-${key}`}>
                {cells.map(({ key, content }) => (
                  <TableCell
                    scope="row"
                    component="th"
                    key={`table-body-cell-${sliceId}-${key}`}
                  >
                    <RichText
                      content={content}
                      variant="default"
                      websiteUrl={WebsiteUrl}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </OxygenTable>
      )}
    </Box>
  );
};
